<template>
  <div style="height: 100%">
    <div style="margin: 1em; text-align: center;">
      <div>
        <el-select style="width: auto;" class="select-primary" size="large" name="latestStatus" placeholder="Date Range" v-model="dateRange">
          <el-option class="select-primary" value="Today" :label="$t('message.Today')"></el-option>
          <el-option class="select-primary" value="This week" :label="$t('message.This week')"></el-option>
          <el-option class="select-primary" value="This month" :label="$t('message.This month')"></el-option>
          <el-option class="select-primary" value="Last 7 days" :label="$t('message.Last 7 days')"></el-option>
          <el-option class="select-primary" value="Last 30 days" :label="$t('message.Last 30 days')"></el-option>
          <el-option class="select-primary" value="Last 90 days" :label="$t('message.Last 90 days')"></el-option>
        </el-select>
      </div>
      <div style="margin-top: 1em;">
        <div style="font-size: 3em; font-weight: bolder;">
          <span style="color:var(--success);">
            <i class="fas fa-rupee-sign" style="color:gray; font-size: 0.7em; position: relative; top: -3px"></i>
            {{totalEarnings}}
          </span>
        </div>
      </div>
    </div>
    <div v-if="totalEarnings>0" style="margin-top: 2em">
      <h5 class="charts-main-heading">{{$t('message.Earnings breakup')}}</h5>
      <div style="height: 50vw;" v-if="earningsChartData.data.length>0">
        <doughnut-chart :labels="earningsChartData.lables" :data="earningsChartData.data" :primaryColor="settings.theming.telemed.primaryColor" :title="'earnings'" height="200" width="250"></doughnut-chart>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from "../components/charts/DoughnutChart.vue";

export default {
  components: {
    DoughnutChart,
  },

  data() {
    return {
      dateRange: "This month",
      fromDate: null,
      toDate: null,
      totalEarnings: null,
      earningsChartData: {
        lables: [],
        data: [],
      },
    };
  },

  async mounted() {
    // setting date range as this month
    let loader = this.$loading.show({
      container: null,
      canCancel: false,
    });

    //setting date range for this month
    let end = new Date();
    let start = new Date();
    let month = start.getMonth();
    start.setMonth(month, 1);
    start.setHours(0, 0, 0, 0);
    this.fromDate = start;
    this.toDate = end;

    await Promise.all([this.getEarnings(), this.renderEarningsChart()]);
    loader.hide();
  },

  methods: {
    async getEarnings() {
      let filter = {};
      if (this.dateRange) {
        filter.fromDate = this.fromDate.getTime();
        filter.toDate = this.toDate.getTime();
      }
      try {
        this.totalEarnings = await this.$store.dispatch(
          "getTotalEarnings",
          filter
        );
      } catch (error) {
        console.log(error);
      }
    },
    async renderEarningsChart() {
      try {
        let filter = {};
        if (this.dateRange) {
          filter.fromDate = this.fromDate.getTime();
          filter.toDate = this.toDate.getTime();
        }
        let data = await this.$store.dispatch("getEarningsStats", filter);
        data.sort((a, b) => {
          if (a._id < b._id) {
            return -1;
          }
          if (a._id > b._id) {
            return 1;
          }
          return 0;
        });
        let lables = data.map((obj) => {
          if (obj._id == "appointment") {
            return (
              this.$t("message.Appointments") +
              " (" +
              obj.count +
              ") - ₹" +
              obj.amount +
              "   "
            );
          } else if (obj._id == "labOrder") {
            return (
              this.$t("message.Lab orders") +
              " (" +
              obj.count +
              ") - ₹" +
              obj.amount +
              "   "
            );
          } else {
            return obj._id;
          }
        });
        let amount = data.map((obj) => obj.amount);

        this.earningsChartData.data = amount;
        this.earningsChartData.lables = lables;
      } catch (error) {
        console.error(error);
      }
    },
  },

  watch: {
    dateRange: async function () {
      let start;
      let end;
      switch (this.dateRange) {
        case "Today":
          end = new Date();
          start = new Date();
          start.setHours(0, 0, 0, 0);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "This week":
          end = new Date();
          start = new Date();
          let day = start.getDay() + 1;
          start.setHours(24, 0, 0, 0);
          start.setTime(start.getTime() - 3600 * 1000 * 24 * day);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "This month":
          end = new Date();
          start = new Date();
          let month = start.getMonth();
          start.setMonth(month, 1);
          start.setHours(0, 0, 0, 0);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "Last 7 days":
          end = new Date();
          start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "Last 30 days":
          end = new Date();
          start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "Last 90 days":
          end = new Date();
          start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          this.fromDate = start;
          this.toDate = end;
          break;

        default:
          break;
      }
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      await Promise.all([this.getEarnings(), this.renderEarningsChart()]);
      loader.hide();
    },
  },

  computed: {
    settings() {
      return this.$store.state.settings;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },
};
</script>

<style scoped>
.chart-sub-heading {
  text-align: center;
  font-weight: 500;
  text-transform: none;
}

.charts-main-heading {
  margin: 1em 0.5em 1em 0.5em;
  border-top: solid 1px #ccc;
  padding-top: 1em;
  text-align: center;
}
</style>
